module.exports = __webpack_public_path__ + "media/images/icon__minus-f921194054d3bed1fe1fa093d4509461.png";